import map from 'lodash/map'
import React, { FC, useContext } from 'react'

import { Link } from '@Components/Link'
import { Button } from '@CoreComponents/Buttons/Button'
import { BlockContext } from '@Globals/CMS/Context'
import { pageTypeToDestinationPageType } from '@Globals/Page/Mappers'
import { useTranslation } from '@Globals/Translations'

import styles from './CategoryListV2.module.scss'

export interface CategoryListV2Item {
  id: string
  link: string
  name: string
  newTab?: boolean
  type?: string
}

export interface CategoryListV2Props {
  backgroundColor?: string
  items: CategoryListV2Item[]
  textColor?: string
}

export const CategoryListV2: FC<CategoryListV2Props> = ({ backgroundColor, items, textColor }) => {
  const { t } = useTranslation()
  const { blockID: sourceID } = useContext(BlockContext)

  const hasHiddenItems = items.length > 10

  return (
    <div
      className={styles.wrapper}
      style={{
        '--category-list-background-color': backgroundColor || 'transparent',
        '--category-list-text-color': textColor || 'inherit',
      } as React.CSSProperties}
    >
      {hasHiddenItems && (
        <input
          className={styles.toggle}
          id="showMoreToggle"
          type="checkbox"
        />
      )}
      <div className={styles.list}>
        {map(items, (item) => {
          if (!item.type || item.type === '') { return null }
          return (
            <Link
              key={item.name}
              analytics={{
                dest_page_type: pageTypeToDestinationPageType(item.type),
                dest_page_type_id: item.id,
                source_id: sourceID || '',
              }}
              className={styles.item}
              href={item.link}
              target={item.newTab ? '_blank' : ''}
            >
              {item.name}
            </Link>
          )
        })}
        {hasHiddenItems && (
          <label className={styles.button} htmlFor="showMoreToggle">
            <Button
              innerSpacing="medium"
              style={{ color: 'var(--category-list-text-color)' }}
              theme="label"
            >
              {t('common:SEE_MORE', 'See more').toUpperCase()}
            </Button>
          </label>
        )}
      </div>
    </div>
  )
}

